/**
 * C4: may the current user reveal a CPR stored on this referral?
 * Same rule as 'Patient-CPR: Se' on the patient page: the referral belongs to
 * the active clinic and the role grants patients_cpr:view (canViewCprIn). The server checks
 * again (decrypt-referral-cpr + private.assert_caller_can_reveal_cpr).
 */
export function canRevealReferralCpr(
  canViewCprIn: (clinicId: string) => boolean,
  activeClinicId: string | null | undefined,
  referralClinicId: string | null | undefined,
): boolean {
  if (!activeClinicId || !referralClinicId) return false;
  if (activeClinicId !== referralClinicId) return false;
  return canViewCprIn(referralClinicId);
}
